"use client";

// components
import HeroSection from "@/components/HeroSection ";
import ProductNavigationTabs from "@/components/ProductNavigationTabs";
import CarSearchFormWrapper from "@/components/pages/car/searchForm";

// utils
import { cdnCarPath } from "@/constants/cdnUrls";
import { useTranslationDetector } from "@/hooks/useTranslationDetector";
import { useWindowWidth } from "@/hooks/useWindowWidth";
import { usePathname } from "@/i18n/navigation";
import { getRouteDetails } from "@/utils/routeHelper";
import { useSearchParams } from "next/navigation";
import { useMemo } from "react";

const HeaderSection = ({
  mainTitle,
  hasHeaderNavigation = true,
  navigationBar = true,
  title = "",
  mobileTitle = "",
  searchComponentProps = {},
}) => {
  const searchParams = useSearchParams();
  const t = useTranslationDetector("Car");
  const pathname = usePathname();
  const isSmallerThan1200 = useWindowWidth() <= 1200;

  const routeDetails = getRouteDetails(pathname);
  const { isCarRentalLanding } = routeDetails;

  const selectedCampaignId = useMemo(() => {
    return searchParams.get("campaignId") || null;
  }, [searchParams]);

  return (
    <HeroSection
      title={
        title || (
          <>
            {t("heroTitleLine1")}
            <br />
            {t("heroTitleLine2")}
          </>
        )
      }
      mainTitle={mainTitle}
      hasHeaderNavigation={hasHeaderNavigation}
      mobileTitle={mobileTitle || t("heroMobileTitle")}
      navigationComponent={navigationBar && ProductNavigationTabs}
      searchComponent={CarSearchFormWrapper}
      backgroundImage={{
        mobile: `${cdnCarPath}${isCarRentalLanding ? "mobile-background-alt" : "mobile-background"}.png`,
        tablet: `${cdnCarPath}desktop-background-small.png`,
        desktop: `${cdnCarPath}desktop-background.png`,
      }}
      backgroundWrapperClassName="!h-auto md:h-full!"
      backgroundImageClassName="!h-[528px] md:h-full!"
      searchComponentProps={{
        ...searchComponentProps,
        scrollToForm: true,
        ...(selectedCampaignId && {
          defaultFilters: { Campaigns: selectedCampaignId },
        }),
      }}
    />
  );
};

export default HeaderSection;
